import { Inject, Injectable, Injector } from '@angular/core';

import { LocusRobotics_ReportService } from './LocusRobotics.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.LocusRobotics = this.injector.get(LocusRobotics_ReportService);
  }
    public LocusRobotics: LocusRobotics_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

